import type React from "react";
import { Button } from "@planta-v2/pds-ui/button";
import { Input } from "@planta-v2/pds-ui/input";
import { i18n } from "@frontend/i18n";
import { useEmailVerificationFlowController } from "../controllers/useEmailVerificationFlowController";

export function EmailVerificationFlow(): React.JSX.Element {
  const { state, actions } = useEmailVerificationFlowController();
  const { flowState, code, errorMessage } = state;

  if (flowState === "verified") {
    return (
      <p
        className="text-xs text-success"
        data-testid="verification-success-message"
      >
        {i18n.t("user.account.settings.verifySuccess")}
      </p>
    );
  }

  if (flowState === "codeSent" || flowState === "validating") {
    return (
      <div className="flex items-center gap-2">
        <div className="flex-1">
          <Input
            placeholder={i18n.t("user.account.settings.enterCode")}
            data-testid="verification-code-input"
            autoComplete="one-time-code"
            value={code}
            onChange={(e) => {
              actions.setCode(e.target.value);
            }}
            disabled={flowState === "validating"}
          />
        </div>
        <Button
          onClick={actions.handleValidate}
          disabled={flowState === "validating" || code.trim() === ""}
          data-testid="verify-button"
        >
          {i18n.t("user.account.settings.verify")}
        </Button>
      </div>
    );
  }

  return (
    <>
      {flowState === "error" && errorMessage !== "" && (
        <p
          className="text-xs text-destructive"
          data-testid="verification-error-message"
        >
          {errorMessage}
        </p>
      )}
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="w-fit"
        onClick={actions.handleSend}
        disabled={flowState === "sending"}
        data-testid="send-verification-button"
      >
        {flowState === "sending"
          ? i18n.t("user.account.settings.verificationSent")
          : i18n.t("user.account.settings.sendVerification")}
      </Button>
    </>
  );
}
